import { DatabaseZap } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { SystemStatus } from '@/types';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { INTERFACE_STATUS_BADGE } from '@/utils/constants';

interface InterfaceStatusBadgeProps {
  status?: SystemStatus;
  className?: string;
  badgeClassName?: string;
}

const InterfaceStatusBadge: FC<InterfaceStatusBadgeProps> = ({
  status,
  className,
  badgeClassName,
}) => {
  const { t } = useTranslation();
  const { className: variantClassName, label = '' } =
    (status && INTERFACE_STATUS_BADGE[status]) ?? {};

  return (
    <div className={cn('flex items-start gap-2', className)}>
      <DatabaseZap className="size-5 shrink-0" />
      <Badge className={cn(variantClassName, badgeClassName)}>
        {t('interface_status.status', { status: t(label) })}
      </Badge>
    </div>
  );
};

export default InterfaceStatusBadge;
